import { Inject, Injectable } from '@angular/core';
import { WINDOW } from './injectable-window';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  constructor(@Inject(WINDOW) private window: Window) {}

  setItem(key: string, value: unknown): void {
    this.window.sessionStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): unknown {
    const item = this.window.sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  removeItem(key: string): void {
    this.window.sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
